<div>
  <!--<form #f="ngForm" novalidate>-->

  <div class="row m-0 col-md-12 p-0 formborder">
    <!--<div class="col-md-4">
    <span class="required-lable">Manufacture</span>
    <input
      type="text"
      name="Manufacture"
      id="Manufacture"
      [(ngModel)]="Manufacture"
      class="form-control input-text-css"
      #refManufacture="ngModel"
      required
      [ngClass]="{
        'is-invalid': f.submitted && refManufacture.invalid,
        'alert-warning':
          refManufacture.invalid &&
          (refManufacture.dirty ||
            refManufacture.touched ||
            refManufacture.untouched)
      }"
    />
  </div>
  <div class="col-md-4">
    <button
      type="button"
      (click)="onSaveManufacture()"
      *ngIf="saveBtn"
      class="mt-3 btn font-size-12 button-btn"
      [class.spinner]="loading"
      [disabled]="!f.form.valid"
    >
      Save
    </button>
    <button
      type="button"
      (click)="UpdateAssetInfo()"
      *ngIf="updateBtn"
      class="mt-3 btn font-size-12 button-btn"
      [class.spinner]="loading"
      [disabled]="!f.form.valid"
    >
      Update
    </button>
  </div>-->

    <div class="col-md-4 p-1 mt-2">
      <!-- <mat-form-field>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Search ....">
    </mat-form-field> -->
      <form action="" class="search-text">
        <div class="bg-light rounded rounded-pill shadow-sm">
          <div class="input-group">
            <input
              type="text"
              id="FilterInputSearch"
              (keyup)="applyFilter($event.target.value)"
              name="FilterInputSearch"
              placeholder="What're you searching for?"
              class="form-control border-0 bg-light"
            />
            <div class="input-group-append">
              <button
                id="button-addon1"
                type="submit"
                class="btn btn-link text-primary"
              >
                <i class="fa fa-search"></i>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="col-md-6">
      <button
        class="mt-3 btn font-size-12 button-btn"
        style="float: right"
        (click)="openAddVehiclemanufacture()"
      >
        Add
      </button>
    </div>
  </div>
  <!--</form>-->
  <div class="table-responsive mt-2">
    <mat-table [dataSource]="dataCustomerSource">
      <ng-container matColumnDef="Number">
        <mat-header-cell
          class="grid-header"
          style="max-width: 50px"
          *matHeaderCellDef
          >#</mat-header-cell
        >
        <mat-cell
          *matCellDef="let row; let i = index"
          class="grid-cell"
          style="max-width: 50px; max-height: 5px"
          >{{ i + 1 }}</mat-cell
        >
      </ng-container>

      <ng-container matColumnDef="Manufacture">
        <mat-header-cell class="grid-header" *matHeaderCellDef>
          Manufacture
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Manufacture }}
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Categories">
        <mat-header-cell class="grid-header" *matHeaderCellDef>
          Categories
        </mat-header-cell>
        <mat-cell *matCellDef="let row" class="grid-cell">
          {{ row.Categories }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell class="grid-header j-c-center" *matHeaderCellDef
          >Action</mat-header-cell
        >
        <mat-cell *matCellDef="let row" class="grid-cell j-c-center">
          <i
            class="fas fa-lg fa-edit margin-right-4xs cursor-style"
            aria-label="true"
            (click)="editAssetInfo(row)"
          ></i>
          <i
            class="fa fa-trash style-delete"
            (click)="removeAssetInfo(row)"
            aria-label="true"
          ></i>
        </mat-cell>
      </ng-container>

      <mat-header-row
        *matHeaderRowDef="displayedCustomerColumns"
      ></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedCustomerColumns"
      ></mat-row>
    </mat-table>
  </div>
</div>

<div class="row m-0 mt-3 formborder" [hidden]="!dataCustomerSource">
  <div class="col-md-4 mt-3">
    <button class="mt-3 btn font-size-12 button-btn" (click)="exportexcelNew()">
      <i
        class="fa fa-file-export mr-1"
        style="font-size: medium; cursor: pointer"
      ></i>
      Export
    </button>
  </div>
  <!-- <div class="col-md-8 mt-3">
    <mat-paginator
      #paginatorRef
      [pageSizeOptions]="[20, 50]"
      showFirstLastButtons
    ></mat-paginator>
  </div> -->
</div>

<table
  id="export_vehicle_manufacture"
  class="table table-bordered bg-white"
  style="font-family: 'Times New Roman', Times, serif; display: none"
>
  <tr>
    <th style="background: #4dc3a3 !important; border: 1px solid white">#</th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Manufacture
    </th>
    <th style="background: #4dc3a3 !important; border: 1px solid white">
      Categories
    </th>
  </tr>
  <tr *ngFor="let x of JsonData; let i = index">
    <td>{{ i + 1 }}</td>
    <td>{{ x.Manufacture }}</td>
    <td>{{ x.Categories }}</td>
  </tr>
</table>

<div
  class="modal fade in"
  id="addVehiclemanufactureModel"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myModalLabel"
  data-backdrop="false"
  style="background-color: rgba(0, 0, 0, 0.5); overflow: auto"
>
  <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="modal-content">
      <div cdkDragHandle class="modal-header" style="padding: 10px">
        <h6 class="modal-title" id="myModalLabel" name="myModalLabel">
          Add Vehicle Manufacture
        </h6>
        <button
          type="button"
          (click)="onCloseModal()"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">
            <i class="far text-black fa-times-circle"></i>
          </span>
        </button>
      </div>
      <div class="modal-body" style="border: none">
        <div class="table-responsive">
          <form #f="ngForm" novalidate class="formborder">
            <div class="row m-0 col-md-12 p-0 d-flex justify-content-between">
              <div class="col-md-4">
                <span class="required-lable">Manufacture</span>
                <input
                  type="text"
                  name="Manufacture"
                  id="Manufacture"
                  [(ngModel)]="Manufacture"
                  class="form-control input-text-css"
                  #refManufacture="ngModel"
                  required
                  [ngClass]="{
                    'is-invalid': f.submitted && refManufacture.invalid,
                    'alert-warning':
                      refManufacture.invalid &&
                      (refManufacture.dirty ||
                        refManufacture.touched ||
                        refManufacture.untouched)
                  }"
                />
              </div>

              <div class="col-md-4">
                <input
                  type="checkbox"
                  id="selectAll"
                  [(ngModel)]="selectAll"
                  name="selectAll"
                  (change)="toggleSelectAll()"
                />
                <label for="selectAll"><strong>Select All</strong></label>
              </div>
            </div>
            <div class="row m-0 col-md-12 p-0 d-flex mt-2">
              <div class="col-md-4" *ngFor="let item of CategoryData">
                <!-- (change)="updateSelectedCategories()" -->
                <input
                  type="checkbox"
                  [(ngModel)]="item.selected"
                  [name]="'checkbox' + item.Int_Id"
                  [id]="'checkbox' + item.Int_Id"
                />
                <label [for]="'checkbox' + item.Int_Id">{{
                  item.Vehicle_Category
                }}</label>
              </div>

              <div class="col-md-4">
                <button
                  type="button"
                  (click)="onSaveManufacture()"
                  *ngIf="saveBtn"
                  class="mt-3 btn font-size-12 button-btn"
                  [class.spinner]="loading"
                  [disabled]="!f.form.valid"
                >
                  Save
                </button>
                <button
                  type="button"
                  (click)="UpdateAssetInfo()"
                  *ngIf="updateBtn"
                  class="mt-3 btn font-size-12 button-btn"
                  [class.spinner]="loading"
                  [disabled]="!f.form.valid"
                >
                  Update
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
